import { __decorate, __extends } from "tslib";
import { CustomElement, attachShadowTemplate, upgradeProperty, FoundationProperty } from '@tyler-components-web/core';
import { tylIconArrowDropDown, tylIconCheckBoxOutlineBlank, tylIconCheckBox } from '@tylertech/tyler-icons/standard';
import { SelectAdapter } from './select-adapter';
import { SelectFoundation } from './select-foundation';
import { SELECT_CONSTANTS } from './select-constants';
import { OptionComponent } from '../option';
import { PopupComponent } from '../../popup';
import { ListComponent, ListItemComponent } from '../../list';
import { OptionGroupComponent } from '../option-group';
import { IconComponent, TylerIconRegistry } from '../../icon';
import { BaseSelectComponent, BASE_SELECT_CONSTANTS } from '../core';
import { ProgressSpinnerComponent } from '../../progress-spinner';
import { ScaffoldComponent } from '../../scaffold';
import { ToolbarComponent } from '../../toolbar';
import { IconButtonComponent } from '../../icon-button';
var template = require('./select.html');
var styles = require('./select.css');
/**
 * The custom element class behind the `<tcw-select>` component.
 */
var SelectComponent = /** @class */ (function (_super) {
    __extends(SelectComponent, _super);
    function SelectComponent() {
        var _this = _super.call(this) || this;
        TylerIconRegistry.define([tylIconArrowDropDown, tylIconCheckBox, tylIconCheckBoxOutlineBlank]);
        attachShadowTemplate(_this, SELECT_CONSTANTS.elementName, template, styles);
        _this._foundation = new SelectFoundation(new SelectAdapter(_this));
        return _this;
    }
    Object.defineProperty(SelectComponent, "observedAttributes", {
        get: function () {
            return [
                SELECT_CONSTANTS.attributes.LABEL,
                SELECT_CONSTANTS.attributes.MULTIPLE,
                SELECT_CONSTANTS.attributes.VALUE,
                SELECT_CONSTANTS.attributes.DISABLED,
                SELECT_CONSTANTS.attributes.INVALID,
                SELECT_CONSTANTS.attributes.REQUIRED,
                SELECT_CONSTANTS.attributes.DENSITY,
                SELECT_CONSTANTS.attributes.FLOAT_LABEL_TYPE,
                SELECT_CONSTANTS.attributes.PLACEHOLDER,
                SELECT_CONSTANTS.attributes.OBSERVE_SCROLL,
                SELECT_CONSTANTS.attributes.OBSERVE_SCROLL_THRESHOLD,
                SELECT_CONSTANTS.attributes.INSET,
                SELECT_CONSTANTS.attributes.DIALOG_WIDTH_THRESHOLD,
                BASE_SELECT_CONSTANTS.attributes.SELECT_ON_BLUR,
                BASE_SELECT_CONSTANTS.attributes.HIGHLIGHT_FIRST,
                BASE_SELECT_CONSTANTS.attributes.POPUP_CLASSES,
                BASE_SELECT_CONSTANTS.attributes.OPTION_LIMIT,
                BASE_SELECT_CONSTANTS.attributes.SYNC_POPUP_WIDTH
            ];
        },
        enumerable: true,
        configurable: true
    });
    SelectComponent.prototype.initializedCallback = function () {
        _super.prototype.initializedCallback.call(this);
        upgradeProperty(this, 'label');
        upgradeProperty(this, 'disabled');
        upgradeProperty(this, 'invalid');
        upgradeProperty(this, 'required');
        upgradeProperty(this, 'density');
        upgradeProperty(this, 'floatLabelType');
        upgradeProperty(this, 'placeholder');
        upgradeProperty(this, 'inset');
    };
    SelectComponent.prototype.attributeChangedCallback = function (name, oldValue, newValue) {
        switch (name) {
            case SELECT_CONSTANTS.attributes.LABEL:
                this.label = newValue;
                return;
            case SELECT_CONSTANTS.attributes.DISABLED:
                this.disabled = this.hasAttribute(SELECT_CONSTANTS.attributes.DISABLED);
                return;
            case SELECT_CONSTANTS.attributes.INVALID:
                this.invalid = this.hasAttribute(SELECT_CONSTANTS.attributes.INVALID);
                return;
            case SELECT_CONSTANTS.attributes.REQUIRED:
                this.required = this.hasAttribute(SELECT_CONSTANTS.attributes.REQUIRED);
                return;
            case SELECT_CONSTANTS.attributes.DENSITY:
                this.density = newValue;
                return;
            case SELECT_CONSTANTS.attributes.FLOAT_LABEL_TYPE:
                this.floatLabelType = newValue;
                return;
            case SELECT_CONSTANTS.attributes.PLACEHOLDER:
                this.placeholder = newValue;
                return;
            case SELECT_CONSTANTS.attributes.INSET:
                this.inset = this.hasAttribute(SELECT_CONSTANTS.attributes.INSET);
                break;
        }
        _super.prototype.attributeChangedCallback.call(this, name, oldValue, newValue);
    };
    /** Sets focus to the internal button element. */
    SelectComponent.prototype.focus = function () {
        this._foundation.setFocus();
    };
    __decorate([
        FoundationProperty()
    ], SelectComponent.prototype, "label", void 0);
    __decorate([
        FoundationProperty()
    ], SelectComponent.prototype, "disabled", void 0);
    __decorate([
        FoundationProperty()
    ], SelectComponent.prototype, "invalid", void 0);
    __decorate([
        FoundationProperty()
    ], SelectComponent.prototype, "required", void 0);
    __decorate([
        FoundationProperty()
    ], SelectComponent.prototype, "density", void 0);
    __decorate([
        FoundationProperty()
    ], SelectComponent.prototype, "floatLabelType", void 0);
    __decorate([
        FoundationProperty()
    ], SelectComponent.prototype, "placeholder", void 0);
    __decorate([
        FoundationProperty()
    ], SelectComponent.prototype, "inset", void 0);
    SelectComponent = __decorate([
        CustomElement({
            name: SELECT_CONSTANTS.elementName,
            dependencies: [
                OptionComponent,
                OptionGroupComponent,
                PopupComponent,
                ListComponent,
                ListItemComponent,
                ProgressSpinnerComponent,
                IconComponent,
                ScaffoldComponent,
                ToolbarComponent,
                IconButtonComponent
            ]
        })
    ], SelectComponent);
    return SelectComponent;
}(BaseSelectComponent));
export { SelectComponent };
